import * as React from 'react';
import { OrderProductionStatus, OrderProductionStatusMetadata } from '../../../models/ordering/enums/order-production-status';

interface IProps {
    status: OrderProductionStatus;
}

/**
 * Where an order is in production, as a colored dot the way the production schedule shows it:
 * grey while it waits, gold while it is in production and green once it is produced.
 * An order that is not produced at all gets a dash.
 */
export const ProductionStatusDot = (props: IProps) => {

    if (props.status === OrderProductionStatus.NotApplicable) {
        return <span className="production-status-na" title="Production not applicable">-</span>;
    }

    const metadata = OrderProductionStatusMetadata[props.status];
    if (metadata === undefined) {
        return null;
    }

    return <span
        className={`production-status-dot ${metadata.class}`}
        title={metadata.display}
        aria-label={metadata.display} />;
};
